var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from '@tanstack/react-query';
import { fetchDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
import { fetchDBTransferReceipts } from '@/lib/db/DBTransferHistoryHelpers';
export function useOrderHistory(_a) {
    var _this = this;
    var orderId = _a.orderId, cloudWallet = _a.cloudWallet, solanaAddress = _a.solanaAddress, tokenAddress = _a.tokenAddress, _b = _a.includeTransfers, includeTransfers = _b === void 0 ? true : _b;
    var query = useQuery({
        queryKey: ['orderHistory', orderId, cloudWallet, tokenAddress, includeTransfers],
        queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
            var orderHistoryPromise, transferHistoryPromise, solanaTransferHistoryPromise, _a, orderHistory, transferHistory, solanaTransferHistory, orderHistoryData, transferHistoryData, solanaTransferHistoryData, mergedHistory;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        orderHistoryPromise = fetchDBOrderHistory({
                            orderId: orderId,
                            tokenAddress: tokenAddress,
                        });
                        transferHistoryPromise = fetchDBTransferReceipts({
                            fromAddress: cloudWallet,
                            toAddress: cloudWallet,
                            tokenAddress: tokenAddress ? tokenAddress : null,
                        });
                        solanaTransferHistoryPromise = fetchDBTransferReceipts({
                            fromAddress: solanaAddress,
                            toAddress: solanaAddress,
                            tokenAddress: tokenAddress ? tokenAddress : null,
                        });
                        return [4 /*yield*/, Promise.all([
                                orderHistoryPromise,
                                includeTransfers ? transferHistoryPromise : Promise.resolve({ data: [] }),
                                includeTransfers ? solanaTransferHistoryPromise : Promise.resolve({ data: [] }),
                            ])];
                    case 1:
                        _a = _b.sent(), orderHistory = _a[0], transferHistory = _a[1], solanaTransferHistory = _a[2];
                        orderHistoryData = orderHistory.data || [];
                        transferHistoryData = (transferHistory.data || []).map(function (transfer) {
                            return __assign(__assign({}, transfer), { created_at: new Date(new Date(transfer.created_at).getTime()).toISOString() });
                        });
                        solanaTransferHistoryData = (solanaTransferHistory.data || []).map(function (transfer) {
                            return __assign(__assign({}, transfer), { created_at: new Date(new Date(transfer.created_at).getTime()).toISOString() });
                        });
                        mergedHistory = __spreadArray(__spreadArray(__spreadArray([], orderHistoryData, true), transferHistoryData, true), solanaTransferHistoryData, true).sort(function (a, b) { var _a, _b; return ((_a = new Date(b === null || b === void 0 ? void 0 : b.created_at)) === null || _a === void 0 ? void 0 : _a.getTime()) - ((_b = new Date(a === null || a === void 0 ? void 0 : a.created_at)) === null || _b === void 0 ? void 0 : _b.getTime()); });
                        return [2 /*return*/, { data: mergedHistory }];
                }
            });
        }); },
        enabled: orderId || cloudWallet ? true : false,
    });
    return query;
}
